import { GET_STARTUP_DATA } from './../constants/actionTypes'

export const getStartupDataAction = data => dispatch => {
  dispatch({
    type: GET_STARTUP_DATA,
    data
  })
}
